import { render } from "./assignTask.vue?vue&type=template&id=1ec76753"
import script from "./assignTask.vue?vue&type=script&lang=js"
export * from "./assignTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__